import { ColumnDef } from '@tanstack/react-table'
import { AppBox, AppTable, AppTypography, SimpleCheckBox } from 'components'
import { getMDYFormattedDate } from 'globals/functions'
import { useMembershipHelper } from 'hooks'
import { FC } from 'react'
import { SubAccountViewModel } from 'sdk'

interface Props {
  subAccount: SubAccountViewModel
  agreementAccepted: boolean
  setAgreementAccepted: (val: boolean) => void
}

export const RemoveSubAccountStepTwoVerify: FC<Props> = ({ subAccount, agreementAccepted, setAgreementAccepted }) => {
  const { CurrentMembership } = useMembershipHelper()
  const columns: ColumnDef<SubAccountViewModel>[] = [
    {
      header: 'Email',
      cell: ({ row }) => {
        return row.original.FirstName + ' ' + row.original.LastName
      },
    },
    {
      header: 'Email',
      accessorKey: 'Email',
    },
    {
      header: 'Removal Date',
      cell: () => {
        return getMDYFormattedDate(new Date())
      },
    },
  ]
  return (
    <AppBox display={'flex'} flexDirection={'column'} justifyContent={'space-between'} height={'100%'} gap={2}>
      <AppBox paddingBottom={6}>
        <AppTypography color={'grey.500'}>
          Please verify that you wish to schedule this user for removal at the end of your current billing cycle
        </AppTypography>
        <AppBox border={1} borderColor={'grey.300'} borderRadius={6} padding={2}>
          <AppTable columns={columns} data={[subAccount]} />
        </AppBox>
      </AppBox>
      <AppBox display={'flex'} alignItems={'center'}>
        <SimpleCheckBox checked={agreementAccepted} onClick={(value) => setAgreementAccepted(!agreementAccepted)} />
        <AppTypography color={'grey.500'}>
          Remove this user from my subscription plan when my current billing cycle ends on{' '}
          {getMDYFormattedDate(new Date(CurrentMembership()?.CurrentPeriodEnd ?? ''))}
        </AppTypography>
      </AppBox>
    </AppBox>
  )
}
